import CrudTemplate from "../crudTemplate";
import EstadoService from "../../services/resource/estadoService";

export default function EstadoCrud() {
    const service = new EstadoService();

    const formFields = [
        { name: "id", label: "Código", type: "input", disabled: true, typeText: "number", colSpan: 1 },
        { name: "nome", label: "Nome", type: "input", colSpan: 1 },
        { name: "uf", label: "UF", type: "input", colSpan: 1 },
    ];

    const tableColumns = [
        { key: "id", label: "Código", bold: true },
        { key: "nome", label: "Nome", bold: true },
        { key: "uf", label: "UF" },
    ];

    return <CrudTemplate
        title="Gerenciar Estados"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        style={{ width: '85%' }}
        modalHeader="Estado"
    />;
}
